module.exports = __webpack_public_path__ + "static/media/icon_drawer.e5c9f195.svg";